module.exports = __webpack_public_path__ + "95ce9a4333fa92c94ce2d3ab39050bcf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/kwast.mp3
// module id = 32
// module chunks = 0